import {formatDate, formatDocumentOrganizationUnit} from "utils/valueFormatter.function";
import type {DocumentDetailsProps} from "types/documentData";
import {DocumentDataField, DocumentDataGrid} from "./DocumentDataField.component";
import {DocumentAmountField} from "./DocumentAmount.component";
import {CostUnitsDetails} from "./CostUnitsDetails.component";
import {getBranchName, getDisplayId} from "./documentData.function";

const ExpenseDocumentDetailsDTO = ({details, translate}: DocumentDetailsProps) => {
    const branchName = getBranchName(details);

    return (
        <>
            <DocumentDataGrid>
                {details.description &&
                    <DocumentDataField id="description" wide label={translate("documentData.description")}
                                       value={details.description}/>}
                {branchName &&
                    <DocumentDataField id="branch" label={translate("documentData.branch")} value={branchName}/>}
                {details.claimant &&
                    <DocumentDataField id="claimant" label={translate("documentData.claimant")} value={details.claimant}/>}
                {Number(details.employeeCode) > 0 &&
                    <DocumentDataField id="employeeCode" label={translate("documentData.employeeCode")}
                                       value={details.employeeCode}/>}
                {Number(details.expenseDate) > 0 &&
                    <DocumentDataField id="expenseDate" label={translate("documentData.expenseDate")}
                                       value={formatDate(details.expenseDate, null)}/>}
                <DocumentDataField id="documentId" label={translate("documentData.documentID")} value={getDisplayId(details)}/>
                <DocumentAmountField details={details} translate={translate}/>
                {Number(details.dueDate) > 0 &&
                    <DocumentDataField id="dueDate" label={translate("documentData.dueDate")}
                                       value={formatDate(details.dueDate, null)}/>}
                {details.documentOrganizationUnit &&
                    <DocumentDataField id="organizationUnit" label={translate("documentData.organizationUnit")}
                                       value={formatDocumentOrganizationUnit(details.documentOrganizationUnit)}/>}
            </DocumentDataGrid>

            {!!details.documentCostUnitList?.length &&
                <CostUnitsDetails costUnitList={details.documentCostUnitList} translate={translate}/>}
        </>
    );
};

export default ExpenseDocumentDetailsDTO;
